import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { NotificationUserInfoResponse } from 'src/types/email_notifications';
import axiosInstance from 'src/utils/axios';

const useNotificationUserInfoQuery = () => useQuery<NotificationUserInfoResponse>({
    queryKey: queryKeys.client.notificationUserInfo(),
    queryFn: async () => {
      const res = await axiosInstance.get<NotificationUserInfoResponse>(
        api.getNotificationUserInfo
      );
      return res.data;
    },
  });

export default useNotificationUserInfoQuery;
